import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { setToken } from "../lib/apiClient";
import { attachFunnel } from "../lib/analytics";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, fetchIdentity } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState(false);
  const hash = typeof window !== "undefined" ? window.location.hash || "" : "";
  const sid = hash.includes("session_id=") ? new URLSearchParams(hash.replace(/^#/, "")).get("session_id") : null;

  useEffect(() => {
    if (!sid || done.current) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setToken(null); // Google session lives in an httpOnly cookie, not localStorage
        setUser(data.user);
        await fetchIdentity(); // peupler identity avant de rendre le dashboard (sinon spinner infini)
        await attachFunnel();
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        setErr(true);
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [sid, navigate, setUser, fetchIdentity]);

  if (!sid) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black text-zinc-300" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-7 h-7 text-amber-500 animate-spin mx-auto mb-3" />
        {err ? "Échec de la connexion Google…" : "Connexion en cours…"}
      </div>
    </div>
  );
}
